import React, { useState, useEffect } from "react";

import { ScrollToTop } from "./dumb-components";
import { PrivateRoute } from "./components";
import { Route, Switch, BrowserRouter as Router } from "react-router-dom";

import RootProvider from "./providers";
// import createHistory from 'history/createBrowserHistory';

import routes from "./routes";
import "./scss/main.scss";
import "./scss/_common.scss";
import "./index.scss";
import "./scss/vivify.min.css";
// const history = createHistory();

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { GC } from "./utilities/GamecentreSevice";
import { storage } from "./utilities/storage";
import { NEW_DATA_EVENT } from "./constants/GameConstants";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

function App(appProps) {

  const [gameDetails, setGameDetails] = useState(null);
  const gameInIframe = (window.location !== window.parent.location);

  const syncData = () => {
    const getGameDetails = storage.get.gameDetails();
    setGameDetails(getGameDetails);
  };

  const handleBlur = () => {
    GC.sendGameBlurredMessage()
  }

  useEffect(() => {
    if (!gameInIframe) {
      // Not calling gamecenter apis if not loaded in it.
      return;
    }
    // Adding timeout to handle React.18 intentinonal re-render on development
    const timeout = setTimeout(() => {
      window.addEventListener("message", GC.messageEventHandler);
      window.addEventListener("blur", handleBlur)
      GC.sendGameLoadMessage();
    }, 0);
    window.addEventListener(NEW_DATA_EVENT, syncData);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("message", GC.messageEventHandler);
      window.removeEventListener(NEW_DATA_EVENT, syncData);
      window.removeEventListener("blur", handleBlur)
    };
  }, []);

  /**  
   *  Render game if any two conditions met 
   *  @param {boolean} gameInIframe - Check game window loaded in iframe to call/not call GC/SDK apis
   *  @param {object} gameDetails - (When game loaded in iframe) Make GC/SDK apis call and set gameData/gameDetails,
   *  which dispatch a window NEW_DATA_EVENT, which sets gameDetails { orgName, mediaUrl, gameName } 
   */  
  return (
    <Sentry.ErrorBoundary
      onError={(err) => console.log(err)}
      fallback={<p>An error has occurred</p>}
    >
      <Router>
        <RootProvider>
        {
          ((!gameInIframe) || (gameDetails)) &&
          <Switch>
            {routes.map(
              ({ path, isProtected, exact, component: Component, ...rest }) =>
                isProtected ? (
                  <PrivateRoute
                    key={path}
                    path={path}
                    exact={exact}
                    containerProps={appProps}
                    component={Component}
                    {...rest}
                  />
                ) : (
                  <Route
                    key={path}
                    path={path}
                    exact={exact}
                    render={(props) => (
                      <ScrollToTop>
                        <Component {...props} {...rest} {...appProps} />
                      </ScrollToTop>
                    )}
                  />
                )
            )}
            <Route
              render={(props) => (
                <ScrollToTop>
                  <h1>404</h1>
                  {/* <Error404 {...props} /> */}
                </ScrollToTop>
              )}
            />
          </Switch>
        }
        </RootProvider>
      </Router>
    </Sentry.ErrorBoundary>
  );
}

export default App;
